<template>
    <div>
        <v-img ref="headerImgMain" :src="require(`@/assets/headers/${headerImage}`)" height="90" :gradient="headerGradient">
            <v-toolbar class="transparent" flat>            
                <h3 class="subheading white--text" :style="pageHeaderClass">{{title}} 
                    <span v-if="title && pageTitle && !isMainMenu">></span>
                    <span v-if="pageTitle && !isMainMenu"> {{pageTitle}}</span>
                </h3>
                <v-toolbar-title class="transparent"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="isTeamPage" outline small dark @click="showMyTeams" :disabled="loading_myteams" class="caption clickable no-uppercase mt-0 mr-6" title="Click to switch team">
                    {{ teamName }}
                </v-btn>
                <img v-if="companyLogo" ref="companyLogoRef" :src="`${companyLogo}?date=${Date.now()}`" :class="isMobile?'company-logo-mobile':'company-logo'" >
            </v-toolbar>

            <div v-if="isMainMenu" class="headline white--text" :style="pageTitleClass">{{pageTitle}}</div>
        
            <!-- 
                TODO - create toolbar here that will accept buttons/icons/menus as props 
                the main menu pageTitle will also be part of this toolbar
            -->

        </v-img>

        <v-dialog v-model="dialogAllMyTeams" width="700">   
            <view-all-my-teams ref="allTeamsRef" @send="setSelectedTeamHandler" :dialogAllMyTeams.sync="dialogAllMyTeams"></view-all-my-teams>
        </v-dialog>
    </div>
</template>
<script>

import teamApi from '@/api/team'
import { setSelectedTeam } from '@/helpers/team-selector'
import commonfn from '@/common/functions' //for refactor

export default {
    components: {
        'view-all-my-teams': ()=> import('@/components/Team/ViewAllTeams'),
    },
    data() {
        return {            
            headerImage: '',
            dialog: false,
            dialogAllMyTeams: false,
            loading_myteams: false,
            headerGradientValues: [
                { name: 'default', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)' },
                { name: 'blue', value: 'to right, rgba(25, 118, 210, 0.5), rgba(0, 0, 0, 0.2)' },
                { name: 'green', value: 'to right, rgba(76, 175, 80, 0.5), rgba(0, 0, 0, 0.4)' },
                { name: 'cyan', value: 'to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)' },
                { name: 'purple', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)' },
                { name: 'brown', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)' },
                { name: 'bluegrey', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)' },
                { name: 'grey', value: 'to right, rgba(100, 0, 0, 0), rgba(0, 0, 0, 0)' }
            ]
        }
    },
    props: ['title', 'pageTitle', 'helpsubject','companyLogo','isMainMenu','isTeamPage'],
    methods: {   
        setSelectedTeamHandler(data) {
            if (this.$store.state.selectedTeamId != data.teamId) {

                // This saves to Vuex
                setSelectedTeam(data) 

                // Notify any active page that they need to refresh their data
                this.$root.$emit('team-changed', 'team-changed-handler')
            }
        },
        async showMyTeams() {
            this.loading_myteams = true
            const response = await teamApi.getMyTeams()
            if (response && response.status == 200) {
                this.$refs.allTeamsRef.setData(response.data.myTeams)
                this.dialogAllMyTeams = true
            }
            this.loading_myteams = false
        },
        setHeaderImageMain() {
            this.headerImage = this.formatHeaderImage(this.$store.state.headerImg) 
            this.$refs.headerImgMain.src = `@/assets/headers/${this.headerImage}?date=${Date.now()}`
        },
        bindRootEventHandlers() {
            this.$root.$on('updateHeaderCompanyLogo', (data) => {
                if (data=='updateHeaderCompanyLogoHandler') {
                    this.$refs.companyLogoRef.src = commonfn.getCompanyLogoUrl()
                }
            })
        },
        formatHeaderImage(imgFileName) {
            return imgFileName.toLowerCase().replace('.darken1','').replace('.darken2','').replace('.darken3','').replace('.darken4','')  
        },
    },
    beforeDestroy() {
        this.$root.$off('updateHeaderCompanyLogo')
    },
    computed: {
        pageTitleClass() {
            if (this.isMobile) return 'margin:0px 0px 5px 21px;'
            else return 'margin:-10px 0px 5px 24px;'
        },
        pageHeaderClass() {
            if (this.isMobile) return 'margin:0px 0px 0px 5px;'
            else return 'margin:-15px 0px 0px 0px;'
        },
        savedCompanyLogo() {
            if (this.$store.state.companyLogo) return this.$store.state.companyLogo
            return 'default.png'
        },
        headerGradient() {
            const header = this.headerImage.split('.')[0]
            if (header)
                return this.headerGradientValues.find(x => x.name == header).value
            
            return this.headerGradientValues.find(x => x.name == 'default').value
        },
        teamName() {
            return this.$store.state.selectedTeamName
        }
    },
    created() {
        this.bindRootEventHandlers() 
        this.headerImage = this.formatHeaderImage(this.$store.state.headerImg)
    },
}
</script>
<style>
  .company-logo-mobile {
    border-radius:5px;
    margin-top:45px;
    height:60px;
    width:60px
  }
  .company-logo {
    border-radius:5px;
    margin-top:30px;
    height:70px;
    width:70px
  }
</style>